import { RemoteDetailsTypes } from '../types';
import { IncidentsEntities } from '../../../edr/incidentsGrid/dataProvider/incidentsCallbacks/IncidentsEntities';
import { IncidentsResources } from '../../../edr/incidentsGrid/dataProvider/incidentsCallbacks/IncidentsResources';
import { VulnerabilitiesNames } from '../../../riskManagement/vulnerabilitiesApp/view/VulnerabilitiesCallbacks/VulnerabilitiesNames';
import { VulnerabilitiesCves } from '../../../riskManagement/vulnerabilitiesApp/view/VulnerabilitiesCallbacks/VulnerabilitiesCves';
import { MisconfigurationsAffectedDevices } from '../../../riskManagement/misconfigurationsApp/view/misconfigurationsCallbacks/MisconfigurationsAffectedDevices';
import { VulnerabilitiesAffectedDevices } from '../../../riskManagement/vulnerabilitiesApp/view/VulnerabilitiesCallbacks/VulnerabilitiesAffectedDevices';
import { UserBehaviorRisksAffectedUsers } from '../../../riskManagement/userBehaviorRisksApp/view/UserBehaviorRisksCallbacks/UserBehaviorRisksAffectedUsers';
import { MisconfigurationsNames } from '../../../riskManagement/common/callbacks/MisconfigurationsNames';
import { RiskManagementUsernames } from '../../../riskManagement/usersApp/view/UserAppCallbacks/RiskManagementUsernames';
import { DevicesNames } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesNames';
import { RiskManagementUsersDepartments } from '../../../riskManagement/usersApp/view/UserAppCallbacks/RiskManagementUsersDepartments';
import { RiskManagementUserDevices } from '../../../riskManagement/usersApp/view/UserAppCallbacks/RiskManagementUserDevices';
import { DevicesFqdn } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesFqdn';
import { DevicesMacs } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesMacs';
import { DevicesRegions } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesRegions';
import { MisconfigurationsRegions } from '../../../riskManagement/misconfigurationsApp/view/misconfigurationsCallbacks/MisconfigurationsRegions';
import { HumanBasedRisksNames } from '../../../riskManagement/common/callbacks/HumanBasedRisksNames';
import { DevicesCves } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesCves';
import { DevicesIp } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesIp';
import { DevicesCloudAccountIds } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesCloudAccountIds';
import { DevicesImageRepos } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesImageRepos';
import { DevicesRegistryHosts } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesRegistryHosts';
import { DevicesClusterNames } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesClusterNames';
import { EasmAssetsInventoryNameProvider } from '../../../easm/assetsInventoryGrid/dataProvider/EasmAssetsInventoryNameProvider';
import { ComplexSuggestedItem } from '../../../ui/gzComplexEnumList/types';
import { RemoteConstantTypes } from '../../../grid/types/common';
import { UserBehaviorRisksRegions } from '../../../riskManagement/userBehaviorRisksApp/view/UserBehaviorRisksCallbacks/UserBehaviorRisksRegions';
import { DevicesResourceId } from '../../../riskManagement/devicesApp/view/devicesCallbacks/DevicesResourceId';
import { UsersRegions } from '../../../riskManagement/usersApp/view/UserAppCallbacks/UsersRegions';
import { UsersResourceId } from '../../../riskManagement/usersApp/view/UserAppCallbacks/UsersResourceId';
import { IncidentsActors } from '../../../edr/incidentsGrid/dataProvider/incidentsCallbacks/IncidentsActors';
import {
  PhasrBevahioralProfileIdentitiesDataProvider
} from '../../../phasrRecommendations/phasrRecommendationsGrid/view/phasrRecommendationGridCallbacks/PhasrBevahioralProfileIdentitiesDataProvider';
import {
  PhasrBehavioralProfileResourcesDataProvider
} from '../../../phasrRecommendations/phasrRecommendationsGrid/view/phasrRecommendationGridCallbacks/PhasrBehavioralProfileResourcesDataProvider';
import {
  PhasrRecommendationNameDataProvider
} from '../../../phasrRecommendations/phasrRecommendationsGrid/view/phasrRecommendationGridCallbacks/PhasrRecommendationNameDataProvider';
import { EasmArtifactsInventoryNameProvider } from '../../../easm/artifactsInventoryGrid/dataProvider/EasmArtifactsInventoryNameProvider';
import { EasmArtifactsInventoryCVEProvider } from '../../../easm/artifactsInventoryGrid/dataProvider/EasmArtifactsInventoryCVEProvider';
import { EasmArtifactsInventoryRelatedAssetsProvider } from '../../../easm/artifactsInventoryGrid/dataProvider/EasmArtifactsInventoryRelatedAssetsProvider';
import { EasmAssetsInventoryRelatedAssetsProvider } from '../../../easm/assetsInventoryGrid/dataProvider/EasmAssetsInventoryRelatedAssetsProvider';
import { EasmAssetsInventoryRelatedArtifactsProvider } from '../../../easm/assetsInventoryGrid/dataProvider/EasmAssetsInventoryRelatedArtifactsProvider';
import {
  PhasrRuleNamesDataProvider
} from '../../../phasrMonitoredRules/phasrMonitoredRulesGrid/dataProvider/PhasrRuleNamesDataProvider';
import { BreachPathResourceNames } from '../../../breachPath/breachPathApp/view/breachPathCallbacks/BreachPathResourceNames';
import { BreachPathCloudAccountIds } from '../../../breachPath/breachPathApp/view/breachPathCallbacks/BreachPathCloudAccountIds';

export class RemoteDataCallbackFactory {
  static getRemoteDataCallback(type: RemoteConstantTypes): any {
    switch (type) {
      case RemoteDetailsTypes.IncidentsActors:
        return IncidentsActors.getRemoteData.bind(this);
      case RemoteDetailsTypes.IncidentsEntities:
        return IncidentsEntities.getRemoteData.bind(this);
      case RemoteDetailsTypes.IncidentsResources:
        return IncidentsResources.getRemoteData.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesName:
        return VulnerabilitiesNames.getRemoteData.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesCve:
        return VulnerabilitiesCves.getRemoteData.bind(this);
      case RemoteDetailsTypes.MisconfigurationsAffectedDevices:
        return MisconfigurationsAffectedDevices.getRemoteData.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesAffectedDevices:
        return VulnerabilitiesAffectedDevices.getRemoteData.bind(this);
      case RemoteDetailsTypes.UserBehaviorRisksAffectedUsers:
        return UserBehaviorRisksAffectedUsers.getRemoteData.bind(this);
      case RemoteDetailsTypes.MisconfigurationsNames:
        return MisconfigurationsNames.getRemoteData.bind(this);
      case RemoteDetailsTypes.RiskManagementUsername:
        return RiskManagementUsernames.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesNames:
        return DevicesNames.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesRegions:
        return DevicesRegions.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesResourceId:
        return DevicesResourceId.getRemoteData.bind(this);
      case RemoteDetailsTypes.MisconfigurationsRegions:
        return MisconfigurationsRegions.getRemoteData.bind(this);
      case RemoteDetailsTypes.UserBehaviorRisksRegions:
        return UserBehaviorRisksRegions.getRemoteData.bind(this);
      case RemoteDetailsTypes.HumanBasedRisksNames:
        return HumanBasedRisksNames.getRemoteData.bind(this);
      case RemoteDetailsTypes.RiskManagementUsersDepartments:
        return RiskManagementUsersDepartments.getRemoteData.bind(this);
      case RemoteDetailsTypes.RiskManagementUsersDevices:
        return RiskManagementUserDevices.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesFqdn:
        return DevicesFqdn.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesMacs:
        return DevicesMacs.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesCves:
        return DevicesCves.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesIp:
        return DevicesIp.getRemoteData.bind(this);
      case RemoteDetailsTypes.UsersRegions:
        return UsersRegions.getRemoteData.bind(this);
      case RemoteDetailsTypes.UsersResourceId:
        return UsersResourceId.getRemoteData.bind(this);
      case RemoteDetailsTypes.EASMAssetsName:
        return EasmAssetsInventoryNameProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.EASMArtifactsName:
        return EasmArtifactsInventoryNameProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.EASMArtifactsCVEs:
        return EasmArtifactsInventoryCVEProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.EASMArtifactsRelatedAssets:
        return EasmArtifactsInventoryRelatedAssetsProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.EASMAssetsRelatedAssets:
        return EasmAssetsInventoryRelatedAssetsProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.EASMAssetsRelatedArtifacts:
        return EasmAssetsInventoryRelatedArtifactsProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileIdentities:
        return PhasrBevahioralProfileIdentitiesDataProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileIdentitiesForRules:
        return PhasrBevahioralProfileIdentitiesDataProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileResources:
        return PhasrBehavioralProfileResourcesDataProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileResourcesForRules:
        return PhasrBehavioralProfileResourcesDataProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.PhasrRecommendationName:
        return PhasrRecommendationNameDataProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.PhasrMonitoredRuleName:
        return PhasrRuleNamesDataProvider.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesCloudAccountIds:
        return DevicesCloudAccountIds.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesImageRepos:
        return DevicesImageRepos.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesRegistryHosts:
        return DevicesRegistryHosts.getRemoteData.bind(this);
      case RemoteDetailsTypes.DevicesClusterNames:
        return DevicesClusterNames.getRemoteData.bind(this);
      case RemoteDetailsTypes.BreachPathResourceNames:
        return BreachPathResourceNames.getRemoteData.bind(this);
      case RemoteDetailsTypes.BreachPathCloudAccountIds:
        return BreachPathCloudAccountIds.getRemoteData.bind(this);
      default:
        throw new Error('Unknown remote details type');
    }
  }

  static getLabelsCallback(type: RemoteConstantTypes) {
    switch (type) {
      case RemoteDetailsTypes.MisconfigurationsNames:
        return MisconfigurationsNames.getLabelsCallback.bind(this);
      case RemoteDetailsTypes.HumanBasedRisksNames:
        return HumanBasedRisksNames.getLabelsCallback.bind(this);

      default:
        return null;
    }
  }

  static getConvertResponseCallback(type: RemoteConstantTypes): (response: Array<any>) => ComplexSuggestedItem[] {
    switch (type) {
      case RemoteDetailsTypes.IncidentsActors:
        return IncidentsActors.convertResponse.bind(this);
      case RemoteDetailsTypes.IncidentsEntities:
        return IncidentsEntities.convertResponse.bind(this);
      case RemoteDetailsTypes.IncidentsResources:
        return IncidentsResources.convertResponse.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesName:
        return VulnerabilitiesNames.convertResponse.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesCve:
        return VulnerabilitiesCves.convertResponse.bind(this);
      case RemoteDetailsTypes.MisconfigurationsAffectedDevices:
        return MisconfigurationsAffectedDevices.convertResponse.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesAffectedDevices:
        return VulnerabilitiesAffectedDevices.convertResponse.bind(this);
      case RemoteDetailsTypes.UserBehaviorRisksAffectedUsers:
        return UserBehaviorRisksAffectedUsers.convertResponse.bind(this);
      case RemoteDetailsTypes.MisconfigurationsNames:
        return MisconfigurationsNames.convertResponse.bind(this);
      case RemoteDetailsTypes.RiskManagementUsername:
        return RiskManagementUsernames.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesRegions:
        return DevicesRegions.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesResourceId:
        return DevicesResourceId.convertResponse.bind(this);
      case RemoteDetailsTypes.MisconfigurationsRegions:
        return MisconfigurationsRegions.convertResponse.bind(this);
      case RemoteDetailsTypes.UserBehaviorRisksRegions:
        return UserBehaviorRisksRegions.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesNames:
        return DevicesNames.convertResponse.bind(this);
      case RemoteDetailsTypes.HumanBasedRisksNames:
        return HumanBasedRisksNames.convertResponse.bind(this);
      case RemoteDetailsTypes.RiskManagementUsersDepartments:
        return RiskManagementUsersDepartments.convertResponse.bind(this);
      case RemoteDetailsTypes.RiskManagementUsersDevices:
        return RiskManagementUserDevices.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesFqdn:
        return DevicesFqdn.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesMacs:
        return DevicesMacs.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesCves:
        return DevicesCves.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesIp:
        return DevicesIp.convertResponse.bind(this);
      case RemoteDetailsTypes.UsersRegions:
        return UsersRegions.convertResponse.bind(this);
      case RemoteDetailsTypes.UsersResourceId:
        return UsersResourceId.convertResponse.bind(this);
      case RemoteDetailsTypes.EASMAssetsName:
        return EasmAssetsInventoryNameProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.EASMArtifactsName:
        return EasmArtifactsInventoryNameProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.EASMArtifactsCVEs:
        return EasmArtifactsInventoryCVEProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.EASMArtifactsRelatedAssets:
        return EasmArtifactsInventoryRelatedAssetsProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.EASMAssetsRelatedAssets:
        return EasmAssetsInventoryRelatedAssetsProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.EASMAssetsRelatedArtifacts:
        return EasmAssetsInventoryRelatedArtifactsProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileIdentities:
        return PhasrBevahioralProfileIdentitiesDataProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileIdentitiesForRules:
        return PhasrBevahioralProfileIdentitiesDataProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileResources:
        return PhasrBehavioralProfileResourcesDataProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileResourcesForRules:
        return PhasrBehavioralProfileResourcesDataProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.PhasrRecommendationName:
        return PhasrRecommendationNameDataProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.PhasrMonitoredRuleName:
        return PhasrRuleNamesDataProvider.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesCloudAccountIds:
        return DevicesCloudAccountIds.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesImageRepos:
        return DevicesImageRepos.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesRegistryHosts:
        return DevicesRegistryHosts.convertResponse.bind(this);
      case RemoteDetailsTypes.DevicesClusterNames:
        return DevicesClusterNames.convertResponse.bind(this);
      case RemoteDetailsTypes.BreachPathResourceNames:
        return BreachPathResourceNames.convertResponse.bind(this);
      case RemoteDetailsTypes.BreachPathCloudAccountIds:
        return BreachPathCloudAccountIds.convertResponse.bind(this);
      default:
        throw new Error('Unknown remote details type');
    }
  }

  static getTypeToIconMappingCallback(type: RemoteConstantTypes): () => Map<number, string> {
    switch (type) {
      case RemoteDetailsTypes.IncidentsEntities:
        return IncidentsEntities.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.IncidentsResources:
        return IncidentsResources.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.MisconfigurationsAffectedDevices:
        return MisconfigurationsAffectedDevices.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesAffectedDevices:
        return VulnerabilitiesAffectedDevices.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.DevicesRegions:
        return DevicesRegions.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.DevicesResourceId:
        return DevicesResourceId.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.MisconfigurationsRegions:
        return MisconfigurationsRegions.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.DevicesNames:
        return DevicesNames.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.RiskManagementUsersDevices:
        return RiskManagementUserDevices.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.DevicesFqdn:
        return DevicesFqdn.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.DevicesMacs:
        return DevicesMacs.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.DevicesIp:
        return DevicesIp.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.EASMAssetsName:
        return EasmAssetsInventoryNameProvider.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.EASMArtifactsName:
        return EasmArtifactsInventoryNameProvider.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.EASMArtifactsRelatedAssets:
        return EasmArtifactsInventoryRelatedAssetsProvider.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.EASMAssetsRelatedAssets:
        return EasmAssetsInventoryRelatedAssetsProvider.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.EASMAssetsRelatedArtifacts:
        return EasmAssetsInventoryRelatedArtifactsProvider.getTypeToIconMapping.bind(this);
      case RemoteDetailsTypes.DevicesRegistryHosts:
        return DevicesRegistryHosts.getTypeToIconMapping.bind(this);
      default:
        return RemoteDataCallbackFactory.getEmptyTypeToIconMapping.bind(this);
    }
  }

  static getExtraFiltersCallback(type: RemoteConstantTypes): () => Array<any> {
    switch (type) {
      case RemoteDetailsTypes.IncidentsEntities:
        return IncidentsEntities.getExtraFilters.bind(this);
      case RemoteDetailsTypes.IncidentsResources:
        return IncidentsResources.getExtraFilters.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesName:
        return VulnerabilitiesNames.getExtraFilters.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesCve:
        return VulnerabilitiesCves.getExtraFilters.bind(this);
      case RemoteDetailsTypes.MisconfigurationsNames:
        return MisconfigurationsNames.getExtraFilters.bind(this);
      case RemoteDetailsTypes.HumanBasedRisksNames:
        return HumanBasedRisksNames.getExtraFilters.bind(this);
      case RemoteDetailsTypes.MisconfigurationsAffectedDevices:
        return MisconfigurationsAffectedDevices.getExtraFilters.bind(this);
      case RemoteDetailsTypes.VulnerabilitiesAffectedDevices:
        return VulnerabilitiesAffectedDevices.getExtraFilters.bind(this);
      case RemoteDetailsTypes.UserBehaviorRisksAffectedUsers:
        return UserBehaviorRisksAffectedUsers.getExtraFilters.bind(this);
      case RemoteDetailsTypes.RiskManagementUsername:
        return RiskManagementUsernames.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesRegions:
        return DevicesRegions.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesResourceId:
        return DevicesResourceId.getExtraFilters.bind(this);
      case RemoteDetailsTypes.MisconfigurationsRegions:
        return MisconfigurationsRegions.getExtraFilters.bind(this);
      case RemoteDetailsTypes.UserBehaviorRisksRegions:
        return UserBehaviorRisksRegions.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesNames:
        return DevicesNames.getExtraFilters.bind(this);
      case RemoteDetailsTypes.RiskManagementUsersDepartments:
        return RiskManagementUsersDepartments.getExtraFilters.bind(this);
      case RemoteDetailsTypes.RiskManagementUsersDevices:
        return RiskManagementUserDevices.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesFqdn:
        return DevicesFqdn.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesMacs:
        return DevicesMacs.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesCves:
        return DevicesCves.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesIp:
        return DevicesIp.getExtraFilters.bind(this);
      case RemoteDetailsTypes.UsersRegions:
        return UsersRegions.getExtraFilters.bind(this);
      case RemoteDetailsTypes.UsersResourceId:
        return UsersResourceId.getExtraFilters.bind(this);
      case RemoteDetailsTypes.EASMAssetsName:
        return EasmAssetsInventoryNameProvider.getExtraFilters.bind(this);
      case RemoteDetailsTypes.EASMArtifactsName:
        return EasmArtifactsInventoryNameProvider.getExtraFilters.bind(this);
      case RemoteDetailsTypes.EASMArtifactsCVEs:
        return EasmArtifactsInventoryCVEProvider.getExtraFilters.bind(this);
      case RemoteDetailsTypes.EASMArtifactsRelatedAssets:
        return EasmArtifactsInventoryRelatedAssetsProvider.getExtraFilters.bind(this);
      case RemoteDetailsTypes.EASMAssetsRelatedAssets:
        return EasmAssetsInventoryRelatedAssetsProvider.getExtraFilters.bind(this);
      case RemoteDetailsTypes.EASMAssetsRelatedArtifacts:
        return EasmAssetsInventoryRelatedArtifactsProvider.getExtraFilters.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileIdentities:
        return PhasrBevahioralProfileIdentitiesDataProvider.getExtraFilters.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileIdentitiesForRules:
        return PhasrBevahioralProfileIdentitiesDataProvider.getExtraFiltersForRules.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileResources:
        return PhasrBehavioralProfileResourcesDataProvider.getExtraFilters.bind(this);
      case RemoteDetailsTypes.PhasrBehavioralProfileResourcesForRules:
        return PhasrBehavioralProfileResourcesDataProvider.getExtraFiltersForRules.bind(this);
      case RemoteDetailsTypes.DevicesCloudAccountIds:
        return DevicesCloudAccountIds.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesImageRepos:
        return DevicesImageRepos.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesRegistryHosts:
        return DevicesRegistryHosts.getExtraFilters.bind(this);
      case RemoteDetailsTypes.DevicesClusterNames:
        return DevicesClusterNames.getExtraFilters.bind(this);
      case RemoteDetailsTypes.BreachPathResourceNames:
        return BreachPathResourceNames.getExtraFilters.bind(this);
      case RemoteDetailsTypes.BreachPathCloudAccountIds:
        return BreachPathCloudAccountIds.getExtraFilters.bind(this);
      default:
        return RemoteDataCallbackFactory.getEmptyExtraFilters.bind(this);
    }
  }

  static getEmptyTypeToIconMapping(): Map<string, string> {
    return new Map([]);
  }

  static getEmptyExtraFilters(): Array<any> {
    return [];
  }
}
